const frameBrowser = {
  frameBrowserHeader: '作品の中のフレームの位置を',
  frameBrowserHeader2: 'こちらから確認できます。',
  yourFrames: 'Your Frames',
  claimFrame: "フレームをリクエストする"
};

module.exports = frameBrowser;
